import * as React from "react";
import { QueryRoute } from "bernie-core";
import { inject } from "mobx-react";
import { formatText } from "bernie-l10n";
import { UitkCard, UitkCardContent, UitkCardLink } from "uitk-react-cards";
import { MapProps } from "./typings";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";
import FullScreenMap from "./FullScreenMap";

const Map = inject("analytics", "routeStore")((props: MapProps) => {
  const { analytics, routeStore, staticMap, destination, pois, hotels, activities } = props;

  const toggleMapDialog = (toggleAction: string) => (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ): void => {
    e.preventDefault();
    if (!routeStore) {
      return;
    }

    const flexTrackingInfo: FlexTrackingInfo = {
      moduleName: `TG.LP.Dest.Map.${toggleAction}`,
      action: Action.CLICK
    };
    sendDelayedTrackEvent(flexTrackingInfo, analytics);

    const sidebarContainer = document.getElementsByClassName("dx-sidebar-content")[0];
    if (toggleAction === "open") {
      if (sidebarContainer) {
        sidebarContainer.classList.add("z-index-250");
      }

      routeStore.updateSearch({ map: "open" });
    } else {
      if (sidebarContainer) {
        sidebarContainer.classList.remove("z-index-250");
      }

      routeStore.closeDialog("map");
    }
  };

  const staticMapBg = { backgroundImage: `url(${staticMap})` };

  return (
    <>
      <UitkCard>
        <UitkCardContent>
          <div className="uitk-cell image-map" style={staticMapBg} />
          <UitkCardLink>
            <a href="#" onClick={toggleMapDialog("open")} data-testid="map-target">
              {formatText("destinationDiscoveryMap.button.open")}
            </a>
          </UitkCardLink>
        </UitkCardContent>
      </UitkCard>

      <QueryRoute query={{ map: "open" }}>
        <FullScreenMap
          destination={destination}
          pois={pois}
          hotels={hotels}
          activities={activities}
          showMap={routeStore && routeStore.queryParams.map === "open"}
          toggleMapDialog={toggleMapDialog}
        />
      </QueryRoute>
    </>
  );
});

export default Map;
